/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const FilePropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});
